import { RawSfError, SfApiResponse } from '@hfc/ui-core';
import { SmallBusinessRepository } from '@/application/smallBusiness/domain/SmallBusinessRepository';
import { SmallBusinessPlanFilters } from '@/application/smallBusiness/domain/SmallBusinessPlanFilters';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { SmallBusinessApplication } from '@/application/smallBusiness/domain/SmallBusinessApplication';
import { UUID } from '@hfc/common/src/types/UUID';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import enrollmentAxios from '@/shared/infrastructure/Axios';
import { SmallBusinessPlanResponse } from '@/planList/domain/SmallBusinessPlanResponse';
import { SmallBusinessLeadInfo } from '@/application/smallBusiness/domain/SmallBusinessLeadInfo';
import { UpdateApplicationApiAdapter } from '@/application/smallBusiness/infrastructure/adapters/UpdateApplicationApiAdapter';
import { SmallBusinessApplicationApiAdapter } from '@/application/smallBusiness/infrastructure/adapters/SmallBusinessApplicationApiAdapter';

export class SmallBusinessApi implements SmallBusinessRepository {

  public async fetchAvailablePlans (filters: SmallBusinessPlanFilters): Promise<SfApiResponse<SmallBusinessPlanResponse>> {
    try {
      const axiosResponse: AxiosResponse = await axios.post(`${import.meta.env.VITE_APP_LEGACY_API_URL}/application/small-business/plans`, filters);

      return {
        success: true,
        data: axiosResponse.data.data
      };
    } catch (error) {
      return {
        success: false,
        error: error as AxiosError<RawSfError>
      };
    }
  }

  public async submitSmallBusinessApplication (application: SmallBusinessApplication): Promise<SfApiResponse<SmallBusinessApplication>> {
    try {
      const axiosResponse: AxiosResponse = await axios.put(`${import.meta.env.VITE_APP_LEGACY_API_URL}/application/small-business/${application.uuid}/complete`, application);

      return {
        success: true,
        data: await SmallBusinessApplicationApiAdapter.apiResponseToEntity(axiosResponse.data.data)
      };
    } catch (error) {
      return {
        success: false,
        error: error as AxiosError<RawSfError>
      };
    }
  }

  public async updateSmallBusinessApplication (application: SmallBusinessApplication): Promise<SfApiResponse<string>> {
    try {
      const axiosResponse: AxiosResponse = await axios.put(`${import.meta.env.VITE_APP_LEGACY_API_URL}/application/small-business/${application.uuid}/update`, await UpdateApplicationApiAdapter.entityToApiRequest(application));

      return {
        success: true,
        data: axiosResponse.data.data.id
      };
    } catch (error) {
      return {
        success: false,
        error: error as AxiosError<RawSfError>
      };
    }
  }

  public async getApplication (uuid: UUID): Promise<SfApiResponse<SmallBusinessApplication>> {
    try {
      const axiosResponse = await enrollmentAxios.get(`${import.meta.env.VITE_APP_LEGACY_API_URL}/application/${APPLICATION_TYPES.SMALL_BUSINESS}/${uuid}`);

      return {
        success: true,
        data: await SmallBusinessApplicationApiAdapter.apiResponseToEntity(axiosResponse.data.data)
      };
    } catch (error) {
      return {
        success: false,
        error: error as AxiosError<RawSfError>
      };
    }
  }

  public async sendLeadInfo (leadInfo: SmallBusinessLeadInfo): Promise<SfApiResponse<void>> {
    try {
      const axiosResponse: AxiosResponse = await axios.post(`${import.meta.env.VITE_APP_LEGACY_API_URL}/application/small-business/send-lead`, leadInfo);

      return {
        success: true,
        data: axiosResponse.data.data
      };
    } catch (error) {
      return {
        success: false,
        error: error as AxiosError<RawSfError>
      };
    }
  }

}
